import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingService } from './services/loading.service';
import { NgIf } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressBarModule,
    NgIf,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'collary-front';
  loading = false;
  subscription: Subscription;
  constructor(public loadingService: LoadingService) {}
  ngOnInit() {
    this.subscription = this.loadingService.getLoading().subscribe((value) => {
      this.loading = value;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
